angular.module('web.cloudplatform').run(['$templateCache', function($templateCache) {

}]);
